import axios from 'axios';
import { SubModule } from 'types/subModule';
import { API_CONFIG } from '../config/apiConfig';

export const subModuleService = {
  async getSubModulesByModuleId(moduleId: number, type: string): Promise<SubModule[]> {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/SubModule/ByModule/${moduleId}?type=${type}`);
    return response.data;
  },

  async saveSubModule(subModule: Partial<SubModule>): Promise<SubModule> {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/SubModule/SaveSubModule`, subModule);
    return response.data;
  },

  deleteSubModule: async (id: number): Promise<void> => {
    await axios.delete(`${API_CONFIG.BASE_URL}/SubModule/${id}`);
  }
}; 